import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10 21v-6H9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 8 14V9q0-.825.588-1.412A1.93 1.93 0 0 1 10 7h4q.825 0 1.412.588Q16 8.175 16 9v5q0 .424-.287.713A.97.97 0 0 1 15 15h-1v6a.97.97 0 0 1-.287.712A.97.97 0 0 1 13 22h-2a.97.97 0 0 1-.713-.288A.97.97 0 0 1 10 21m2-15q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 4q0-.824.588-1.413A1.93 1.93 0 0 1 12 2q.825 0 1.412.587Q14 3.176 14 4c0 .824-.196 1.02-.588 1.412A1.93 1.93 0 0 1 12 6" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }